import { Controller } from "stimulus"

import Rails from "@rails/ujs";

export default class extends Controller {
  sharer(event) {
    let url = '/torneios/' + event.currentTarget.id + '/share';

    Rails.ajax({
      type: 'POST',
      url: url
    });
  }
}